export default __webpack_public_path__ + "static/media/login-img3.2724388d.png";